/** Shared external links for Nivalabs.ai */
export const CALENDLY_URL = "https://calendly.com/nivalabs-ai/30min";
